"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
exports.fetchListing = fetchListing;
exports.fetchListings = fetchListings;
exports.fetchListingsMeta = fetchListingsMeta;
exports.fetchingListing = fetchingListing;
exports.fetchingListings = fetchingListings;
exports.fetchingListingsMeta = fetchingListingsMeta;
exports.getListing = getListing;
exports.getListingsMeta = getListingsMeta;
exports.getSearch = getSearch;
exports.invalidate = invalidate;
exports.normalize = void 0;
exports.receiveListing = receiveListing;
exports.receiveListings = receiveListings;
exports.receiveListingsMeta = receiveListingsMeta;
var _objectSpread7 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _utils = require("./utils");
exports.keystringify = _utils.keystringify;
var _createMappedReducer; // Re export keystringify so that it can be imported from here
var FETCHING_LISTINGS = 'FETCHING_LISTINGS';
var RECEIVE_LISTINGS = 'RECEIVE_LISTINGS';
var FETCHING_LISTING = 'FETCHING_LISTING';
var RECEIVE_LISTING = 'RECEIVE_LISTING';
var INVALIDATE = 'INVALIDATE';
var FETCHING_LISTINGS_META = 'FETCHING_LISTINGS_META';
var RECEIVE_LISTINGS_META = 'RECEIVE_LISTINGS_META';
var initialState = (0, _freeze["default"])({
  entities: {},
  meta: {},
  searches: {}
});
var DEFAULT_LISTING = (0, _freeze["default"])((0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, _utils.DEFAULT_LOADABLE), {}, {
  id: undefined
}));
var DEFAULT_META = (0, _freeze["default"])((0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, _utils.DEFAULT_LOADABLE), {}, {
  id: undefined
}));
var DEFAULT_SEARCH = (0, _freeze["default"])((0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, _utils.DEFAULT_LOADABLE), {}, {
  items: [],
  totalResults: undefined
}));

/**
 * Normalize a network response and return an object containing the
 * new entities, items and totalResults.
 *
 * BEFORE:
 *  {
 *    results: [
 *      {
 *        id: '12345',
 *        ...,
 *      }
 *    ],
 *    totalResults: 1,
 *  }
 *
 * AFTER:
 *  {
 *    entities: {
 *      '12345': {
 *        loading: false,
 *        id: '12345',
 *        ...,
 *      }
 *    },
 *    items: ['12345'],
 *    totalResults: 1,
 *  }
 *
 * TODO: This needs to be set up to deal with normalising complex queries
 * that aren't designed to give us a full listings but only small chunks
 * of data from multiple listings.
 *
 * @param {Object} data, the raw network response
 *
 * @return {Object} normalized, { _entities, items, totalResults }
 */
var normalize = exports.normalize = function normalize(data) {
  if (data === void 0) {
    data = {};
  }
  var _data = data,
    _data$results = _data.results,
    results = _data$results === void 0 ? [] : _data$results,
    _data$totalResults = _data.totalResults,
    totalResults = _data$totalResults === void 0 ? 0 : _data$totalResults;

  /* eslint-disable no-param-reassign */
  return (0, _reduce["default"])(results).call(results, function (previous, current) {
    var id = current.id;
    current.loading = false;
    current.loaded = true;
    previous._entities[id] = current;
    previous.items.push(id);
    return previous;
    /* eslint-enable no-param-reassign */
  }, {
    _entities: {},
    items: [],
    totalResults: totalResults
  });
};

/**
 * LISTINGS STORE STRUCTURE
 *
 * {
 *   entities: {
 *     '12345': {
 *       id: '12345',
 *       loading: false,
 *       ...,
 *     },
 *     '54321': {
 *       id: '54321',
 *       loading: false,
 *       ...,
 *     },
 *   },
 *   searches: {
 *     // all current sales
 *     '["", "SAL", ["CUR"]]': {
 *       '1': {
 *         // page 1
 *         loading: false,
 *         items: ['12345'],
 *       }
 *     },
 *      // Satans non-current sales
 *     '["666", "SAL", ["SLD", LSE]]': {
 *       // page 5
 *       '5': {
 *         loading: true,
 *       }
 *     },
 *   }
 * }
 */

var reduceFetchingListings = function reduceFetchingListings(state, action) {
  var _objectSpread2, _objectSpread3;
  var key = action.key,
    page = action.page;
  return (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state), {}, {
    searches: (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state.searches), {}, (_objectSpread3 = {}, _objectSpread3[key] = (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state.searches[key]), {}, (_objectSpread2 = {}, _objectSpread2[page] = (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, DEFAULT_SEARCH), {}, {
      loading: true
    }), _objectSpread2)), _objectSpread3))
  });
};
var reduceReceiveListings = function reduceReceiveListings(state, action) {
  var _objectSpread4, _objectSpread5;
  var key = action.key,
    page = action.page,
    data = action.data,
    error = action.error;
  var _normalize = normalize(data),
    _entities = _normalize._entities,
    items = _normalize.items,
    totalResults = _normalize.totalResults;
  return (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state), {}, {
    entities: (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state.entities), _entities),
    searches: (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state.searches), {}, (_objectSpread5 = {}, _objectSpread5[key] = (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state.searches[key]), {}, (_objectSpread4 = {}, _objectSpread4[page] = (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, DEFAULT_SEARCH), {}, {
      items: items,
      loaded: true,
      loading: false,
      error: error,
      totalResults: totalResults
    }), _objectSpread4)), _objectSpread5))
  });
};
var reduceFetchingListingsMeta = function reduceFetchingListingsMeta(state, _ref) {
  var ids = _ref.ids;
  var loading = (0, _reduce["default"])(ids).call(ids, function (result, id) {
    // eslint-disable-next-line no-param-reassign
    result[id] = (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, DEFAULT_META), {}, {
      loading: true,
      id: id
    });
    return result;
  }, {});
  return (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state), {}, {
    meta: (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state.meta), loading)
  });
};
var reduceReceiveListingsMeta = function reduceReceiveListingsMeta(state, _ref2) {
  var ids = _ref2.ids,
    data = _ref2.data,
    error = _ref2.error;
  var loaded = (0, _reduce["default"])(data).call(data, function (result, datum) {
    // Disregard any non-requested data
    if ((0, _indexOf["default"])(ids).call(ids, datum.id) === -1) return result;

    // eslint-disable-next-line no-param-reassign
    result[datum.id] = (0, _objectSpread7["default"])((0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, DEFAULT_META), {}, {
      loaded: true
    }, datum), {}, {
      error: error
    });
    return result;
  }, {});
  var missing = (0, _reduce["default"])(ids).call(ids, function (result, id) {
    if (loaded[id]) {
      return result;
    }

    // eslint-disable-next-line no-param-reassign
    result[id] = (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, DEFAULT_META), {}, {
      loaded: true,
      notFound: true,
      id: id,
      error: error
    });
    return result;
  }, {});
  return (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state), {}, {
    meta: (0, _objectSpread7["default"])((0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state.meta), loaded), missing)
  });
};
var reduceFetchingListing = function reduceFetchingListing(state, action) {
  var _objectSpread6;
  var id = action.id;
  return (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state), {}, {
    entities: (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state.entities), {}, (_objectSpread6 = {}, _objectSpread6[id] = (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, DEFAULT_LISTING), {}, {
      id: id,
      loading: true
    }), _objectSpread6))
  });
};
var reduceReceiveListing = function reduceReceiveListing(state, action) {
  var data = action.data,
    id = action.id,
    error = action.error;
  var _normalize2 = normalize(data, (0, _now["default"])()),
    _entities = _normalize2._entities;
  var nextState = (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state), {}, {
    entities: (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state.entities), _entities)
  });

  // Mark not found listings as loaded but not found
  if (!nextState.entities[id].loaded) {
    nextState.entities[id] = (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, nextState.entities[id]), {}, {
      loaded: true,
      loading: false,
      notFound: true,
      error: error
    });
  }
  return nextState;
};

// TODO: Implement.
var reduceInvalidate = function reduceInvalidate(state) {
  return state;
};
var reducer = (0, _utils.createMappedReducer)((_createMappedReducer = {}, _createMappedReducer[FETCHING_LISTINGS] = reduceFetchingListings, _createMappedReducer[RECEIVE_LISTINGS] = reduceReceiveListings, _createMappedReducer[FETCHING_LISTING] = reduceFetchingListing, _createMappedReducer[RECEIVE_LISTING] = reduceReceiveListing, _createMappedReducer[FETCHING_LISTINGS_META] = reduceFetchingListingsMeta, _createMappedReducer[RECEIVE_LISTINGS_META] = reduceReceiveListingsMeta, _createMappedReducer[INVALIDATE] = reduceInvalidate, _createMappedReducer), initialState);
var _default = exports["default"] = reducer;
function fetchingListingsMeta(ids) {
  return {
    type: FETCHING_LISTINGS_META,
    ids: ids
  };
}
function receiveListingsMeta(ids, data, _temp) {
  var _ref3 = _temp === void 0 ? {} : _temp,
    _ref3$error = _ref3.error,
    error = _ref3$error === void 0 ? false : _ref3$error;
  return {
    type: RECEIVE_LISTINGS_META,
    ids: ids,
    data: data,
    error: error
  };
}

/**
 * Syncronously notify the store that a set of listings are being
 * fetched.
 *
 * @param {String} key, the stringified query
 * @param {String} page, the page number
 *
 * @return {Void}
 */
function fetchingListings(key, page) {
  return {
    type: FETCHING_LISTINGS,
    key: key,
    page: page
  };
}
function receiveListings(key, page, data, _temp2) {
  var _ref4 = _temp2 === void 0 ? {} : _temp2,
    _ref4$error = _ref4.error,
    error = _ref4$error === void 0 ? false : _ref4$error;
  return {
    type: RECEIVE_LISTINGS,
    key: key,
    page: page,
    data: data,
    error: error
  };
}

/**
 * @param {String} id, the id of the listing being fetched
 *
 * @return {Object} action
 */
function fetchingListing(id) {
  return {
    type: FETCHING_LISTING,
    id: id
  };
}

/**
 * @param {String} id, the id of the listing being fetched
 * @param {Object} data, the api response
 *
 * @return {Object} action
 */
function receiveListing(id, data, _temp3) {
  var _ref5 = _temp3 === void 0 ? {} : _temp3,
    _ref5$error = _ref5.error,
    error = _ref5$error === void 0 ? false : _ref5$error;
  return {
    type: RECEIVE_LISTING,
    id: id,
    data: data,
    error: error
  };
}

/**
 * TODO: implement reducer.
 *
 * @param {String} id or key, the id of the listing being fetched
 * @param {String} page, if undefined, a single listings (id) is invalidated
 *
 * @return {Object} action
 */
function invalidate(key, page) {
  return {
    type: INVALIDATE,
    key: key,
    page: page
  };
}

/**
 * Should a network request be performed given what the store
 * currently knows about the listings?
 *
 * @param {Object} state
 * @param {String} key, the stringified query
 * @param {String} page, the page number
 *
 * @return {Boolean} shouldFetchListings?
 */
function shouldFetchListings(state, key, page) {
  var search = state.searches[key];

  // search key doesn't exist
  if (!search || !search[page]) {
    return true;
  }

  //  same request is in flight
  if (search[page].loading) {
    return false;
  }
  return false; // eslint made me.
}

/**
 * Retrieve a listings given an id.
 *
 * @param {Object} store.getState() (or listings object if reducers are combined)
 */
function getListing(state, id) {
  return state.entities[id] || (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, DEFAULT_LISTING), {}, {
    id: id
  });
}

/**
 * Access the contents of a previous search using current state (listings), the
 * query object and page. In order to retreive all the pages for a given query,
 * `-1` can be passed as the page number.
 *
 * @param {Object} - store.getState() (or listings object if reducers are combined)
 * @param {Object} - the query object used to retrieve the listings
 * @param {String|Integer} - the page number or `-1` for all listings
 *
 * @return {Object} - the search page (or pages) and associated entities.
 */
function getSearch(state, query, page) {
  var _context2;
  // Note: key must be based on originally given search with modification
  var key = (0, _utils.keystringify)(query);
  var searches = state.searches,
    entities = state.entities;
  var search = searches[key];
  if (!search) {
    return DEFAULT_SEARCH;
  }
  var meta;
  if (page === -1) {
    // Get *all* pages in the store
    var keys = (0, _keys["default"])(search);
    meta = (0, _reduce["default"])(keys).call(keys, function (result, _page) {
      var _context;
      var _search$_page = search[_page],
        items = _search$_page.items,
        totalResults = _search$_page.totalResults,
        loaded = _search$_page.loaded,
        loading = _search$_page.loading,
        error = _search$_page.error;

      /* eslint-disable no-param-reassign */
      result.items = (0, _concat["default"])(_context = result.items).call(_context, items);
      result.totalResults = result.totalResults || totalResults;
      result.loaded = result.loaded && loaded;
      result.loading = result.loading || loading;
      result.error = result.error || error;
      /* eslint-enable no-param-reassign */

      return result;
    }, (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, DEFAULT_SEARCH), {}, {
      loaded: !!keys.length
    }));
  } else {
    // Get a specific page in the store
    if (!search[page] || !search[page].items) {
      return DEFAULT_SEARCH;
    }
    meta = search[page];
  }
  return (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, meta), {}, {
    items: (0, _map["default"])(_context2 = meta.items).call(_context2, function (item) {
      return entities[item];
    })
  });
}

/**
 * Asyncronously dispatch (using redux-thunk) a network request for
 * some listings, or don't (if up to data for the search and page
 * already exists).
 *
 * This thunks inner function will potentially dispatch several other
 * actions; fetchingListings(), receiveListings()>
 *
 * @param {Function} api, the api call used to retrieve listings
 * @param {Object} query, object representing query params
 *
 * @return {Promise} the promise returned from the inner function
 */
function fetchListings(api, search, page, organisationId) {
  return function (dispatch, getState) {
    // Note: key must be based on originally given search with modification
    var key = (0, _utils.keystringify)(search);
    var from = page ? (search.size || 10) * (page - 1) : undefined;
    var _page = page || 1;
    var _search = (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, search), {}, {
      organisationId: organisationId || search.organisationId,
      from: from
    });
    var _getState = getState(),
      listings = _getState.listings;
    if (!shouldFetchListings(listings, key, _page)) {
      return _promise["default"].resolve(getSearch(listings, search, _page, organisationId));
    }
    dispatch(fetchingListings(key, _page)); // notify store
    return api(_search).then(function (data) {
      return dispatch(receiveListings(key, _page, data));
    })["catch"](function (error) {
      return dispatch(receiveListings(key, _page, undefined, {
        error: error
      }));
    }).then(function () {
      return getSearch(getState().listings, search, _page, organisationId);
    });
  };
}

/**
 * The single listings verison
 */
function shouldFetchListing(state, id) {
  var listing = getListing(state, id);
  if (listing.loading) {
    return false;
  }
  return !listing.loaded;
}

/**
 * Load a specific listing by ID.
 *
 * Note that this will load a listing for any office; additional filtering must
 * be done to ensure that only appropriate listings are displayed, see RULES.md
 * and utils/rules:mayShowListing() for details.
 *
 * @param {Fucntion} api, the api call to grab a listing
 * @param {String} id, the id of the listing being fetched
 *
 * @return {Object} action
 */
function fetchListing(api, id) {
  return function (dispatch, getState) {
    var _getState2 = getState(),
      listings = _getState2.listings;
    if (!id) {
      return _promise["default"].reject(new Error('No ID given to fetch listing by.'));
    }
    if (!shouldFetchListing(listings, id)) {
      return _promise["default"].resolve(getListing(listings, id));
    }
    dispatch(fetchingListing(id)); // notify store
    return api({
      id: id,
      statusCode: ['SLD', 'LSE', 'CUR']
    }).then(function (data) {
      return dispatch(receiveListing(id, data));
    })["catch"](function (error) {
      return dispatch(receiveListing(id, undefined, {
        error: error
      }));
    }).then(function () {
      return getListing(getState().listings, id);
    });
  };
}
function getListingsMeta(state, ids) {
  return (0, _reduce["default"])(ids).call(ids, function (result, id) {
    // eslint-disable-next-line no-param-reassign
    result[id] = state.meta[id] || (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, DEFAULT_META), {}, {
      id: id
    });
    return result;
  }, {});
}
function fetchListingsMeta(api, ids) {
  return function (dispatch, getState) {
    var _getState3 = getState(),
      listings = _getState3.listings;
    var missingIds = (0, _utils.getMissingKeys)(ids, listings.meta);
    if (!missingIds.length) {
      // No organisations to load
      return _promise["default"].resolve(getListingsMeta(listings, ids));
    }
    dispatch(fetchingListingsMeta(missingIds));
    return api({
      identifier: missingIds
    }).then(function (data) {
      return dispatch(receiveListingsMeta(missingIds, data));
    })["catch"](function (error) {
      return dispatch(receiveListingsMeta(missingIds, [], {
        error: error
      }));
    }).then(function () {
      return getListingsMeta(getState().listings, ids);
    });
  };
}